module.exports = __webpack_public_path__ + "img/parks-2-4.aa8da995.jpg";